export default __webpack_public_path__ + "static/media/wtflogo.3a45b341.png";